<template>
  <div>
          <top-navbar></top-navbar>
  
  
          <div class=" mb-5" >
            <h6 class="manage-boder pt-2 font1 font-bold1"> <a class="decoration" to="/"> Home </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Product Sales </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Product GIN </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/gin/index"> Manage GIN  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Update GIN :{{  }} </h6>
              <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
<div class="container-fluid">
<div class="card custom_bdr_rds">
<div style="background-color: #f2f3f4; " class="card-body custom_bdr_rds">


                  <form @submit.prevent="UpdateGin()" >

<div class="row">
  <div class="col-md-3">
  <div class="form-group required">
          <label class="custom-label" style="font-size: small;">Issue Date </label>
          <input type="date" v-model="squatation.issues_date"   style="font-size: small;" class="form-control font-size_def" required>
  </div>
</div>
  <div class="col-md-3">
  <div class="form-group required">
          <label class="custom-label" style="font-size: small;">Customer</label>
          <v-select class="font-size_def" label="label"  @input="loadcontact"  v-model="squatation.idcustomer"  :options="mcustomers" disabled></v-select>
  </div>
</div>

<div class="col-md-3">
  <div class="form-group required">
          <label class="custom-label" style="font-size: small;">Type</label>
          <input  v-model="squatation.SI_type"   style="font-size: small;" class="form-control font-size_def" disabled>
  </div>
</div>
<div class="col-md-3">
  <div class="form-group required">
          <label class="custom-label" style="font-size: small;">Sales Person</label>
          <v-select class="font-size_def" label="label" v-model="sales" :options="salespeoples" disabled></v-select>
  </div>
</div>







</div>

<div class="row">
  
  <div class="col-md-3">
  <div class="form-group ">
          <label class="custom-label" style="font-size: small;">Remarks</label>
         <textarea v-model="quotation.SI_remarks" class="form-control" rows="2"></textarea>
  </div>
</div>
<div class="col-md-3">
  <div class="form-group required">
          <label class="custom-label" style="font-size: small;">Delivery Address</label>
          <v-select class="font-size_def" label="label" v-model="delivery_add " :options="delivery_add" ></v-select>
  </div>
</div>

<!-- <div class="col-md-3">
  <div class="form-group required">
          <label class="custom-label" style="font-size: small;">Brand </label>
         
          <v-select class="font-size_def" label="value" v-model="quotation.id_brand"  :options="mbrands"  @input="loadBrand"></v-select>
  </div>
</div> -->

<!-- <div class="col-md-3">
  <div class="form-group ">
          <label class="custom-label" style="font-size: small;">Payment Method </label>
          <v-select class="font-size_def" label="value" v-model="quotation.payment_method"  :options="paymentmethods" ></v-select>
  </div>
</div> -->
<!-- <div class="col-md-3">
  <div class="form-group ">
          <label class="custom-label" style="font-size: small;">Sales Order Type</label>
          <v-select class="font-size_def" label="label"  v-model="so_type" :options="oder_types" ></v-select>
  </div>
</div> -->
<!-- <div class="col-md-3">
  <div class="form-group">
          <label class="custom-label" style="font-size: small;">Upload CPO</label>
          <input type="file"   style="font-size: small;" class="form-control font-size_def" >
  </div>
</div> -->

</div>




<div class="card custom_bdr_rds">
<div class="card-body custom_bdr_rds">
<h6 class="purchitem mb-2"><b>Available Items for GIN</b></h6>
  <div class="table-responsive mb-1">
    <table style="font-size: small; " class="table  table-sm table-hover ">
      <thead>
        <tr>
            
              <th  >   
                <div class="form-group custom-form required">
                  <label class="custom-label"> Product Code</label>
                </div>
              </th>
              <th  >   
                <div class="form-group custom-form required">
                  <label class="custom-label">Product Description</label>
                </div>
              </th>
              <th>
                <div class="form-group custom-form  ">
                  <label class="custom-label"> BIN Location</label>
                </div>
              </th>
             
              <th>
                <div class="form-group custom-form text_right required">
                  <label class="custom-label"> Qty</label>
                </div>
              </th>
             
             
              
            
           
          </tr>
        </thead>
        <tbody>

          <tr v-for="(quatation_detail, index) in quatation_details" :key="quatation_detail.id">
              <input v-model="quatation_detail.id" type="hidden"  style="font-size: small;" class="form-control">
            
             
            <td   >{{quatation_detail.P_code}}</td>
            <td >{{quatation_detail.P_description}}</td>
            <td >{{quatation_detail.bin_location}}</td>
          <td class="text_right">
          {{quatation_detail.SD_qty}}
          </td>
            
         
         
            
            
          </tr>
         
         
       


        </tbody>
    </table>

    </div>

</div>
</div>



<br>






  

  <div style="border-bottom: 0px; padding-top: 0px; background-color: #f2f3f4;" class="navbar">
  
  <div class="d-flex  ">
  
  </div>
  <div class="d-flex  ">
      <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Update</button>
  </div>
  </div>
  <br><br>


</form>




              </div>
              </div>
            </div> 
          </div>
  
          <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
          <content-footer></content-footer>
  </div>
  
  </template>
  <script src="/js/vue-select/vue-select.js"> </script>
  <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/vue/1.0.13/vue.min.js"></script>
  <script>
    import vSelect from 'vue-select';
    import 'vue-select/dist/vue-select.css';
   import axios from 'axios';
   import authService from '@/auth.service';
    import TopNavbar from './../../layout/TopNavbar.vue'
    import ContentFooter from './../../layout/ContentFooter.vue'
   
  
  
    export default {

      mounted(){
  this.loadSalespeople();
  this.loadCustomer();
  this.loadAlldata();
    },
      data() {
        return {
          access_token:authService.isLoggedIn(),
          userid:authService.isUserid(),
          'id':this.$route.query.id,
          count: 0,
      total:0,
      selectedOption: null, // Store the selected option
      subtotal:"0.00",
      gpmrg_total:"0.00",
      gpMrgPre_total:"0.00",
      final_total:"0.00",
      mcustomers:[],
      mproducts:[],
      contacts:[],
      delivery_add:[],
    salespeoples:[

    ],
    squatation:{},
    totalamt:{},
      customer:{},
      
      quotation:{},
        'so_type':{
          label:'Spare Parts',
          
        },
     
      sales:{},
    
      quatation_details:[],
      detail:[
    {},  
    ],
    paymentmethods: [
          { label: 'Cash', value: 'Cash' },
          { label: '30 Days Credit', value: '30 Days Credit' },
          { label: '45 Days Credit', value: '45 Days Credit' },
          { label: '60 Days Credit', value: '60 Days Credit' },
          // Add more options as needed
      ],
    
      oder_types: [
          { label: 'Spare Parts', value: 'Spare Parts' },
          { label: 'Warranty SO', value: 'Warranty SO' },
       
        
          // Add more options as needed
      ],
         
        }
  
      },
      components :{
        'v-select': vSelect,
          ContentFooter,
          TopNavbar,
         
      },

      methods : {
  

          async loadAlldata() {
     
   
     try {
       const { data} = await  axios.post('/istockissue/loadupdatedata',{id:this.id},{
         headers:{
           'Authorization':'Bearer '+this.access_token,
           'Content-type': 'application/json',
          
         }
        });
        console.log(data);
        this.squatation = data.all_data;
        this.quotation = data.all_data1;
        this.sales = data.sales;
        this.quatation_details = data.quatation_details;
        this.delivery_add = data.delivery_add;
        this.totalamt = data.totalamt;
       
     } catch (error) {
       console.log(error.response);
     }
   },

        async loadSalespeople() {
     
   
    try {
      const { data} = await  axios.get('/msalespeople/salespeopleload',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.salespeoples = data.item_list;
      
    } catch (error) {
      console.log(error.response);
    }
  },

  
  async loadCustomer() {
     
   
     try {
       const { data} = await  axios.get('/mcustomer/customerload',{
         headers:{
           'Authorization':'Bearer '+this.access_token,
           'Content-type': 'application/json',
          
         }
        });
        console.log(data);
        this.mcustomers = data.customers;
        this.contacts = data.contacts;
        this.mbrands = data.mbrands;
        this.mproducts = data.mproducts;
       
     } catch (error) {
       console.log(error.response);
     }
   },

   async loadcontact() {
     
   
     try {
       const { data} = await  axios.post('/mcustomer/loadcontact',{idcustomer:this.squatation.idcustomer},{
         headers:{
           'Authorization':'Bearer '+this.access_token,
           'Content-type': 'application/json',
          
         }
        });
        console.log(data);
        this.contacts = data.contacts;
        this.sales = data.salespeoples;
        
       
     } catch (error) {
       console.log(error.response);
     }
   },

  
  async UpdateGin() {
     
    console.log(this.squatation);
    console.log(this.quotation);

  console.log("amila");
     try {
       const { data} = await  axios.post('/istockissue/update',{id:this.id,userid:this.userid,squatation:this.squatation,quotation:this.quotation,sales:this.sales,delivery_add:this.delivery_add},{
         headers:{
           'Authorization':'Bearer '+this.access_token,
           'Content-type': 'application/json',
          
         }
        });
        console.log(data);
        if(data.status==200){
        this.$router.push('/gin/view?id='+this.id);
      }
        
         
       
     } catch (error) {
       console.log(error.response);
     }
   },
     

      add: function(){
          this.count++;
          this.detail.push({
           
          },)
         
      },

remove: function () {
          this.count--;
          this.detail.splice({
            
          },1)
          
      },

  },
  
  }
  
  </script>

  <style scoped>
    /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
  display: block;
} */
  </style>
  